<template>
    <div>
        <div style="" class="leftTitle mt-3 clearfix ">
            <!--Jazyky-->
            <!--<li></li>-->
            <span class="languages">{{$t("language.1")}}</span>:
        </div>                
        <div style="" class="mt-1 clearfix">
            <!--Slovenčina-->
            <div class="otherInfoLeft  "><span class="slovak">{{$t("language.2")}}</span>:</div>
            <!--Materinský-->
            <div class="otherInfoLeft bold "><span class="maternal ">{{$t("language.3")}}</span></div>
        </div>
        <div style="" class="mt-1 clearfix">
            <!--Čeština-->
            <div class="otherInfoLeft  "><span class="czech">{{$t("language.4")}}</span>:</div>
            <!--Rozumiem-->
            <div class="otherInfoLeft bold "><span class="understand  ">{{$t("language.5")}}</span></div>
        </div>
        <div style="" class="mt-1 clearfix">
            <!--Angličtina-->
            <div class="otherInfoLeft  "><span class="English ">{{$t("language.6")}}</span>:</div>
            <!--Technická-->
            <div class="otherInfoLeft bold "><span class="technical">{{$t("language.7")}}</span></div>
        </div>

    </div>
</template>

<script>
    export default {
        
    }
</script>

<style lang="scss" scoped>

</style>